import $ from 'jquery'
import page from '../../../components/page'
import Inputc from '../../../components/input.vue'
import search from '../../../components/search'
import {CommonUtil} from '../../../common/CommonUtil.js';
import {api, msg, getHallCode,imgPath} from '../../../common/config.js';
import {ajaxUtil} from '../../../common/AjaxUtil.js';
import {StorageUtil, LocalStorageUtil} from '../../../common/Auth.js';
import {store} from '../../../store/store.js';

export default {
  name: 'readercomments',
  data() {
    return {
      imgPath:imgPath,
      msgList: [
        {
          isSupport: false,//是否点赞
          count: 3,//点赞个数
        },
        {
          isSupport: false,//是否点赞
          count: 5,//点赞个数
        }
      ],
      to: '',
      contact: '',//	联系方式
      content: '',//留言内容
      contact_copy: '', /*联系方式的复本*/
      file: null,
      base64: '',
      base64Size: 0, /*图片大小*/
      leaveSuccess: false,
      isSubmit: false,//false可以提交,true不可以提交
      isLeave: false,
      filter: '', //兼容ie9滤镜
      deleteNews: false,
      replysPop: false,
      deleteId: 0,
      replyItem:null,
      webType: store.webType,
      opacType: store.opacType,
      pageCount: 2,
      pageNo: 1,
      libCode: '',
      libId: 0,
      libLevel: '',
      readermessageData: {},
      readerReplymessageData: {},
      totalPage: 0,
    }
  },
  computed: {
    fontCount: function () {
      return (300 - this.content.length)
    },
    isLogin: function () {
      return store.wrap.user ? true : false; //true已登录，false未登录，弹出登陆框
    },
    readerId: function () {
      return store.user ? store.user.readerId : '';
    }
  },
  components: {
    Inputc,
    page,
    search
  },
  watch: {
    $route() {
      this.queryData()
    }
  },
  beforeRouteLeave: function (to, from, next) {
    if ((this.content || this.contact || this.file) && to.path != '/signup' && to.path != '/forget') {
      this.to = to.fullPath;
      this.isLeave = true;
      next(false)
    } else {
      next()
    }
  },
  beforeMount() {
    if (store.webType == 1) {
      store.wrap.activeRouteName = '读者留言'
    } else {
      store.libraryNav.activeNav = '读者留言'
    }
    this.queryData();
  },
  mounted() {
    import ('../../../common/jquery-form.js');
    /*删除按钮*/
    if (this.readerId) {
      return false
    };
    var librarywriteData = StorageUtil.getObject("librarywrite");
    if (librarywriteData != null) {
      this.contact = librarywriteData.contact;
      this.contact_copy = librarywriteData.contact;
      this.content = librarywriteData.content;
    }
    if (this.contact_copy) {
      this.contact = this.contact_copy
    }
  },
  watch:{
    $route() {
      this.queryData();
    },
    readermessageData: {
      handler(oldValue, newValue) {
      },
      deep: true
    }
  },
  methods: {
    queryData() {
      this.pageNo = this.$route.query.page || 1;
      this.libCode = this.$route.query.libCode || this.$route.query.hallCode || '';
      this.libId = this.$route.query.libId || '';
      this.libLevel = this.$route.query.libLevel || '';
      this.getMessage();
    },

    checkLogin() {
      if (!this.isLogin) {
        store.index.$refs.login.showLogin();
        $('#content').blur();
      }
    },
    getMessage() {
      let url = api.library.msgList.replace('{libCode}', this.libCode)
          .replace('{pageCount}', this.pageCount)
          .replace('{pageNo}', this.pageNo)
          .replace('{readerId}', this.readerId) + "&nonceStr=" + (new Date());
      ajaxUtil.ajaxJson(url, null, "GET", (data) => {
        this.readermessageData = data;
        this.totalPage = data.totalPage;
        data.resultList.forEach((item, index) => {
          this.readermessageData.resultList[index].isOwn = item.isOwn;
        })
      }, null, this)
    },
    getReplyMessage() {
      let url = api.library.messageReplyList.replace('{messageId}', this.replyItem.id)
          .replace('{pageCount}',100)
          .replace('{pageNo}', 0)
          .replace('{readerId}', this.readerId) + "&nonceStr=" + (new Date());
      ajaxUtil.ajaxJson(url, null, "GET", (data) => {
        data.resultList.map((item)=>{
          let replyNameVal=item.replyNickName!=null?item.replyNickName:item.replyName;
          let classColorReplyVar="<span style='color:"+(item.replyName.indexOf('管理员-')>=0?"#0C4BBD":"")+"'>";
          if(item.repliedName || item.repliedNickName){
            let classColorRepliedVar="<span style='color:"+(item.repliedName.indexOf('管理员-')>=0?"#0C4BBD":"")+"'>";
            let repliedNameVal=item.repliedNickName!=null?item.repliedNickName:item.repliedName;
            item.replyName =classColorReplyVar+replyNameVal+"</span>" +"<span style='color:#333'>回复</span>"+classColorRepliedVar+repliedNameVal+"</span>";
          }else{
            item.replyName =classColorReplyVar+replyNameVal+"</span>";
          }
        })
        this.readerReplymessageData = data;
      }, null, this)
    },
    deleteTip(id) {
      this.deleteNews = true;
      this.deleteId = id;
    },
    replyTip(item) {
      this.replysPop=true;
      this.replyItem=item;
      this.getReplyMessage();
    },
    /**
     * 删除留言
     * @param id
     */
    makeDelete() {
      let delData = {
        msgId: this.deleteId,
        readerId: this.readerId,
      };
      ajaxUtil.ajaxLogin(api.library.delMsg, delData, 'POST', (data) => { //成功
        if (this.readermessageData.resultList.length - 1 == 0) {
          if (this.pageNo - 1 != 0) {
            CommonUtil.mergeQuery(this, {page: this.pageNo - 1})
          } else {
            this.getMessage()
          }
        } else {
          this.getMessage()
        }
        this.deleteNews = false;
      }, (result) => { //失败
        /*alert("删除失败!");*/
      }, this);
    },

    onPraise(index) {
      this.msgList[index].isSupport = true;
      this.msgList[index].count++
    },
    paging: function (pageNo) {
      CommonUtil.mergeQuery(this, {page: pageNo})
    },
    del() {
      document.getElementById('file').value = '';
      this.filter = '';
      this.base64 = '';
      this.file = '';
    },
    upfileChange: function () {
      if (!this.isLogin) {
        store.index.$refs.login.showLogin();
        return;
      }
      var path = $("#file").val();
      if (path != null && path.trim() != '') {
        this.file = path;
        var userAgent = navigator.userAgent;
        var isIE = userAgent.indexOf("MSIE") > -1;
        if (isIE) { //兼容ie9
          var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
          reIE.test(userAgent);
          var fIEVersion = parseFloat(RegExp["$1"]);
          if (fIEVersion === 9) {
            var ele = document.getElementById('file');
            ele.select();
            ele.blur();
            var urlLocation = document.selection.createRange().text;
            this.filter = "progid:DXImageTransform.Microsoft.AlphaImageLoader(sizingMethod='scale',src='" + urlLocation + "')";
            $('.showIe').css('filter', this.filter)
          }
        } else {
          this.showImg()
        }
      }
    }
    ,
    showImg: function () {
      var file = document.getElementById('file').files[0];
      this.base64Size = file.size / 1024
      if (this.base64Size > 500) {
        CommonUtil.setInfo('上传失败!')
        document.getElementById('file').value = '';
        this.filter = '';
        this.base64 = '';
        this.base64Size = 0;
        this.file = '';
        return false
      }
      var reader = new FileReader();
      var _this = this;
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        _this.base64 = this.result;
      }
    }
    ,

    make: function () {
      this.leaveSuccess = false;
    },

    //确认离开页面
    makeLeave: function () {
      this.isLeave = false;
      this.content = '';
      this.contact = '';
      this.file = null;
      StorageUtil.removeObject("librarywrite");
      this.$router.push({path: this.to});
    },
    cancle: function () {
      this.isLeave = false;
      if (store.webType == 1) {
        store.wrap.activeRouteName = '读者留言'
      } else {
        store.libraryNav.activeNav = '读者留言'
        store.wrap.activeRouteName = '图书馆'
      }
    },
    cancleMsg() {
      this.deleteId = 0;
      this.deleteNews = false;
      this.replyItem=null;
      this.replysPop = false;
      this.readerReplymessageData={};
    },
    loginSuccess() {
    },
    submit: function () {
      this.contact_copy=this.contact;
      document.getElementById("contact").value=this.contact;
      this.content = this.content.replace(/[\r\n]/g, "").replace(/\r/g, "&nbsp;").replace(/\n/g, "<br />").trim();
      if (store.func.getUserObj() == null) {
        store.index.$refs.login.showLogin();
        return;
      }
      if (this.isSubmit) {
        return;
      }
      this.isSubmit = true;
      if (!this.content && !this.file) return false;
      let _this = this;
      $("#myForm").ajaxSubmit({
        accept: "application/json",
        url: api.library.pubMsg,
        data:{'readerId':this.readerId,'libCode':this.libCode},
        enctype: 'multipart/form-data',
        headers: {
          token: store.func.getToken(),
        },
        dataType: 'json',
        success: function (data) {
          //进不了error，先在这里捕捉
          if (data.status == '200') {
            StorageUtil.removeObject("librarywrite");
            _this.contact = '';//	联系方式
            _this.contact_copy = '';//	联系方式
            _this.content = '';//留言内容
            _this.base64 = '';
            _this.file = null;
            if(_this.opacType === 0){
              document.getElementById('file').value = '';
            }
            _this.leaveSuccess = true;
            _this.isSubmit = false;
            _this.pageNo=1;
            _this.getMessage()
          } else if (data.data.errorCode == '30100') {
            var saveData = {
              content: _this.content,
              contact: _this.contact,
            };
            StorageUtil.storeObject("librarywrite", saveData);
            _this.isLeave = false;
            store.wrap.$refs.repeat.isShow(0);
            _this.isSubmit = false;
            return;
          } else {
            _this.isSubmit = false;
            if(data.data.errorCode == 2322){
              CommonUtil.setInfo("你已入本馆黑名单，被限制该业务操作!");
            }else{
              CommonUtil.setInfo("发布留言失败!");
            }

          }
        }, error: function (data) {
          /*if (data.data.errorCode === 30100) {
           _this.isShow = 1;//未登录,弹出登陆框
           }*/
        }
      });
    }
  }
}
